import { RpcReportData } from './rpc-report-model';

/**
 * Rpc report data sever side handler interface.
 */
export interface RpcReportHandler {
    handler(data: RpcReportData): Promise<void>;
}
